{
  "name": "@trigger.dev/sdk",
  "version": "2.3.18",
  "description": "trigger.dev Node.JS SDK",
  "license": "MIT",
  "main": "./dist/index.js",
  "types": "./dist/index.d.ts",
  "module": "./dist/index.mjs",
  "publishConfig": {
    "access": "public"
  },
  "files": [
    "dist"
  ],
  "exports": {
    ".": {
      "import": {
        "types": "./dist/index.d.mts",
        "default": "./dist/index.mjs"
      },
      "require": "./dist/index.js",
      "types": "./dist/index.d.ts"
    },
    "./package.json": "./package.json"
  },
  "scripts": {
    "clean": "rimraf dist",
    "build": "npm run clean && npm run build:tsup",
    "build:tsup": "tsup --dts-resolve",
    "typecheck": "tsc --noEmit"
  },
  "dependencies": {
    "@trigger.dev/core": "workspace:^2.3.18",
    "@trigger.dev/core-backend": "workspace:^2.3.18",
    "chalk": "^5.2.0",
    "cronstrue": "^2.21.0",
    "debug": "^4.3.4",
    "evt": "^2.4.13",
    "get-caller-file": "^2.0.5",
    "git-remote-origin-url": "^4.0.0",
    "git-repo-info": "^2.1.1",
    "slug": "^6.0.0",
    "terminal-link": "^3.0.0",
    "ulid": "^2.3.0",
    "uuid": "^9.0.0",
    "ws": "^8.11.0",
    "zod": "3.22.3"
  },
  "devDependencies": {
    "@trigger.dev/tsconfig": "workspace:*",
    "@types/debug": "^4.1.7",
    "@types/node": "18",
    "@types/slug": "^5.0.3",
    "@types/uuid": "^9.0.0",
    "@types/ws": "^8.5.3",
    "encoding": "^0.1.13",
    "rimraf": "^3.0.2",
    "tsup": "^8.0.1",
    "@trigger.dev/tsup": "workspace:*",
    "typed-emitter": "^2.1.0",
    "typescript": "^5.3.0"
  },
  "engines": {
    "node": ">=18.0.0"
  }
}